const CtxMenu = ({ ctxMenu, handlers }) => {
  const { r, c } = ctxMenu;
  const close = handlers.close;

  const action = (fn) => (e) => {
    e.stopPropagation();
    fn();
    close();
  };

  return (
    <div
      className="xg-ctx-menu"
      style={{ top: ctxMenu.y, left: ctxMenu.x }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="xg-ctx-item"
        onClick={action(() => handlers.startEdit(r, c))}
      >
        ✏️ Edit Cell
      </div>
      <div className="xg-ctx-item" onClick={action(handlers.copySelection)}>
        ⎘ Copy
      </div>
      <div className="xg-ctx-sep" />
      <div
        className="xg-ctx-item"
        onClick={action(() => handlers.insertRowAbove(r))}
      >
        ↑ Insert Row Above
      </div>
      <div
        className="xg-ctx-item"
        onClick={action(() => handlers.insertRowBelow(r))}
      >
        ↓ Insert Row Below
      </div>
      <div
        className="xg-ctx-item"
        onClick={action(() => handlers.insertColLeft(c))}
      >
        ← Insert Col Left
      </div>
      <div
        className="xg-ctx-item"
        onClick={action(() => handlers.insertColRight(c))}
      >
        → Insert Col Right
      </div>
      <div className="xg-ctx-sep" />
      <div
        className="xg-ctx-item"
        onClick={action(() => handlers.sortCol(c, true))}
      >
        ↑ Sort A→Z
      </div>
      <div
        className="xg-ctx-item"
        onClick={action(() => handlers.sortCol(c, false))}
      >
        ↓ Sort Z→A
      </div>
      <div className="xg-ctx-sep" />
      <div
        className="xg-ctx-item danger"
        onClick={action(() => handlers.deleteRow(r))}
      >
        🗑 Delete Row
      </div>
      <div
        className="xg-ctx-item danger"
        onClick={action(() => handlers.deleteCol(c))}
      >
        🗑 Delete Column
      </div>
    </div>
  );
};

export default CtxMenu;
